
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPTextInfo extends Vue {
  @Prop({ default: '' })
  public readonly title?: string
}
